import React, { useState, useEffect } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { CasinoLink } from './CasinoLink.jsx';

const QUICK_ACCESS_ITEMS = [
    { key: "prematch", href: "https://m.supersport.hr/", icon: "content/images/more-menu/ico-prematch.png", label: "Sport", sublabel: "Prije igre", className: "qa-prematch" },
    { key: "live", href: "https://m.supersport.hr/uzivo", icon: "content/images/more-menu/ico-live.png", label: "Uživo", sublabel: "Uživo sada", className: "qa-live" },
    { key: "casino", to: "/", icon: "content/images/more-menu/ico-casino.png", label: "Casino", sublabel: "Sve igre", className: "qa-casino" }
];

const MENU_SECTIONS = [
    {
        key: "igraj", title: "IGRAJ", type: "card-grid",
        items: [
            { key: "loto", href: "https://m.supersport.hr/loto", icon: "content/images/more-menu/ico-loto.png", label: "Loto" },
            { key: "virtuali", href: "https://m.supersport.hr/virtuali", icon: "content/images/more-menu/ico-virtuali.png", label: "Virtuali" },
            { key: "poker", to: "/poker", icon: "content/images/more-menu/ico-poker.png", label: "Poker" }
            
        ]
    },
    // {
    //     key: "sport", title: "SPORT", type: "card-grid-4",
    //     items: [
    //         { key: "rezultati", href: "https://m.supersport.hr/ponuda/livescore", icon: "content/images/more-menu/ico-rezultati.png", label: "Rezultati" },
    //         { key: "statistika", href: "https://s5.sir.sportradar.com/supersport2/", icon: "content/images/more-menu/ico-statistika.png", label: "Statistika" },
    //         { key: "blog", href: "https://m.supersport.hr/blog", icon: "content/images/more-menu/ico-blog.png", label: "Blog" },
    //         { key: "poslovnice", href: "https://m.supersport.hr/poslovnice", icon: "content/images/more-menu/ico-poslovnice.png", label: "Poslovnice" },
    //         { key: "sporti-app", href: "https://m.supersport.hr/download", icon: "content/images/more-menu/ico-sporti-app.png", label: "Sporti app" },
    //         { key: "casino-app", to: "/download", icon: "content/images/more-menu/ico-casino-app.png", label: "Casino app" }
    //     ]
    // },
    {
        key: "casino", title: "CASINO", type: "card-grid-4",
        items: [
            { key: "superklub", to: "/account/superklub", icon: "content/images/more-menu/ico-superklub.png", label: "SuperKlub" },
            { key: "superspin", to: "/account/superspin", icon: "content/images/more-menu/ico-superspin.png", label: "SuperSpin" },
            { key: "provideri", to: "/provideri", icon: "content/images/more-menu/ico-provideri.png", label: "Provideri" },
            { key: "teme", to: "/teme", icon: "content/images/more-menu/ico-teme.png", label: "Teme" },
            { key: "casino-utrke", to: "/casino-utrke", icon: "content/images/more-menu/ico-casino-utrke.png", label: "Casino utrke" },
            { key: "promocije", to: "/promotions", icon: "content/images/more-menu/ico-promocije.png", label: "Promocije" },
            { key: "dobitnici", to: "/winners", icon: "content/images/more-menu/ico-dobitnici.png", label: "Dobitnici" },
            { key: "blog-casino", href: "https://m.supersport.hr/blog", icon: "content/images/more-menu/ico-blog-casino.png", label: "Blog" },
            { key: "casino-app-2", to: "/download", icon: "content/images/more-menu/ico-casino-app-2.png", label: "Casino aplikacija" },
            { key: "poker-app", to: "/poker/download", icon: "content/images/more-menu/ico-poker-app.png", label: "Poker aplikacija" },
            { key: "bonusi", to: "/account/bonuses", icon: "content/images/more-menu/ico-bonusi.png", label: "Bonusi" }
        ]
    },
    {
        key: "izgled", title: "IZGLED", type: "list",
        items: [
            { key: "prilagodi-izgled", to: "/promjena-teme", icon: "content/images/more-menu/ico-izgled.png", label: "Prilagodi izgled", chevron: true }
        ]
    },
    {
        key: "pomoc", title: "POMOĆ I PODRŠKA", type: "list",
        items: [
            { key: "centar-pomoc", href: "https://mcasino.supersport.hr/pravila/faq", icon: "content/images/more-menu/ico-pomoc.png", label: "Centar za pomoć", chevron: true },
            { key: "kontakt", href: "mailto:ssport@supersport.hr", icon: "content/images/more-menu/ico-kontakt.png", label: "Kontaktiraj podršku", chevron: true }
        ]
    },
    {
        key: "pravila", title: "PRAVILA I UVJETI", type: "list",
        items: [
            { key: "o-nama", href: "https://mcasino.supersport.hr/pravila/o-tvrtki", icon: "content/images/more-menu/ico-o-nama.png", label: "O nama", chevron: true },
            { key: "odgovorno", href: "https://mcasino.supersport.hr/pravila/odgovorno-igranje", icon: "content/images/more-menu/ico-odgovorno.png", label: "Odgovorno igranje", chevron: true },
            { key: "politika-privatnosti", href: "https://mcasino.supersport.hr/pravila/obavijest-o-obradi-osobnih-podataka", icon: "content/images/more-menu/ico-politika-privatnosti.png", label: "Politika privatnosti", chevron: true },
            { key: "18plus", href: "https://mcasino.supersport.hr/pravila/plus18", icon: "content/images/more-menu/ico-18plus.png", label: "18+", chevron: true },
            {
                key: "pravila-igara", icon: "content/images/more-menu/ico-pravila.png", label: "Pravila igara i klađenja",
                expandable: "expandedPravila",
                children: [
                    { key: "opca-pravila", href: "https://mcasino.supersport.hr/pravila/opca-pravila", label: "Opća pravila" },
                    { key: "sportsko-kladjenje", href: "https://mcasino.supersport.hr/pravila/opca-pravila?vrsta=kladenje", label: "Pravila sportskog klađenja" },
                    { key: "slot-igre", href: "https://mcasino.supersport.hr/pravila/opca-pravila?vrsta=automati", label: "Pravila slot igara" },
                    { key: "stolne-igre", href: "https://mcasino.supersport.hr/pravila/opca-pravila?vrsta=stolovi", label: "Pravila stolnih igara" },
                    { key: "poker-pravila", href: "https://mcasino.supersport.hr/pravila/opca-pravila?vrsta=poker", label: "Pravila pokera" }
                ]
            },
            {
                key: "ostali-uvjeti", icon: "content/images/more-menu/ico-ostali-uvjeti.png", label: "Ostali uvjeti korištenja",
                expandable: "expandedOstaliUvjeti", noRedOnExpand: true,
                children: [
                    { key: "kolacici", href: "https://mcasino.supersport.hr/pravila/politika-kolacica", label: "Pravila kolačića" },
                    { key: "info-sigurnost", href: "https://www.supersport.hr/doc/politika-informacijske-sigurnosti.pdf", label: "Politika informacijske sigurnosti" },
                    { key: "stadion-uvjeti", href: "https://www.supersport.hr/doc/chat-uvjeti-koristenja.pdf", label: "Uvjeti korištenja Stadiona" },
                    // { key: "chat-uvjeti", to: "/pravila/chat-uvjeti", label: "Uvjeti korištenja Chata" },
                    { key: "superklub-pravila", href: "https://mcasino.supersport.hr/pravila/pravila-superkluba", label: "Pravila SuperKluba" },
                    { key: "superspin-pravila", href: "https://mcasino.supersport.hr/pravila/pravila-superspina", label: "Pravila SuperSpina" }
                ]
            },
            { key: "popis-igara", to: "/popis-igara", icon: "content/images/more-menu/ico-popis-igara.png", label: "Popis igara", chevron: true }
        ]
    },
    {
        key: "drustvene-mreze", title: "DRUŠTVENE MREŽE", type: "list",
        items: [
            { key: "facebook", href: "https://www.facebook.com/SSuperhr", icon: "content/images/more-menu/ico-facebook.png", label: "Facebook", chevron: false },
            { key: "instagram", href: "https://www.instagram.com/supercasino.hr/", icon: "content/images/more-menu/ico-instagram.png", label: "Instagram", chevron: false }
        ]
    }
];

function MoreMenu(props) {
    var [expandedPravila, setExpandedPravila] = useState(true);
    var [expandedOstaliUvjeti, setExpandedOstaliUvjeti] = useState(false);
    var [, setThemeVersion] = useState(0);

    useEffect(() => {
        var handler = () => setThemeVersion(v => v + 1);
        window.addEventListener("casinoThemeChange", handler);
        return () => window.removeEventListener("casinoThemeChange", handler);
    }, []);

    useEffect(() => {
        if (!props.showMoreMenu) return;
        var html = document.getElementsByTagName("html")[0];
        if (!html) return;
        var prev = html.style.overflow;
        html.style.overflow = "hidden";
        return () => {
            html.style.overflow = prev;
        };
    }, [props.showMoreMenu]);

    var currentIsDark = casino.utils.getCasinoTheme() === "dark";
    var isPokerPath = props.location && props.location.pathname && props.location.pathname.startsWith('/poker');
    var applyDark = currentIsDark && !isPokerPath;
    var isLoggedIn = props.userChecked && props.user;
    var isIos = casino.utils.isIos();
    var menuSections = MENU_SECTIONS.map(section => {
        if (section.key !== "casino") return section;

        return {
            ...section,
            items: section.items.filter(item => !(isIos && item.key === "casino-app-2")).map(item => {
                if (item.key === "superklub") {
                    return {
                        ...item,
                        to: isLoggedIn ? "/account/superklub" : "/promotions/superklub"
                    };
                }

                if (item.key === "superspin") {
                    return {
                        ...item,
                        to: isLoggedIn
                            ? "/account/superspin"
                            : { pathname: "/login", state: { from: "/account/superspin" } }
                    };
                }

                return item;
            })
        };
    });

    function themedSrc(src) {
        if (!applyDark || !src) return src;
        var dotIndex = src.lastIndexOf(".");
        if (dotIndex === -1) return src + "-dark";
        return src.substring(0, dotIndex) + "-dark" + src.substring(dotIndex);
    }

    function closeMenu() {
        props.toggleMoreMenuFn(false);
    }

    function renderLink(item, className, children) {
        if (item.href) {
            return (
                <a key={item.key} href={item.href} target="_blank" rel="noopener noreferrer" className={className} onClick={closeMenu}>
                    {children}
                </a>
            );
        }
        return (
            <NavLink key={item.key} to={item.to} className={className} onClick={closeMenu}>
                {children}
            </NavLink>
        );
    }

    function renderGridItem(item) {
        return renderLink(item, "more-menu-grid-item", <>
            <div className="more-menu-grid-icon">
                <img src={themedSrc(item.icon)} alt={item.label} />
            </div>
            <span className="more-menu-grid-label">{item.label}</span>
        </>);
    }

    function renderListItem(item) {
        return renderLink(item, "more-menu-list-item", <>
            <div className="more-menu-list-icon">
                <img src={themedSrc(item.icon)} alt={item.label} />
            </div>
            <span className="more-menu-list-label">{item.label}</span>
            {item.chevron && <span className="more-menu-chevron"><img src={themedSrc("content/images/more-menu/ico_chevron_right.png")} alt="" /></span>}
        </>);
    }

    function renderExpandableItem(item) {
        var expandedMap = { expandedPravila: expandedPravila, expandedOstaliUvjeti: expandedOstaliUvjeti };
        var setterMap = { expandedPravila: setExpandedPravila, expandedOstaliUvjeti: setExpandedOstaliUvjeti };
        var isExpanded = expandedMap[item.expandable];
        var setExpanded = setterMap[item.expandable];
        return (
            <div key={item.key} className={"more-menu-expandable" + (isExpanded ? " expanded" : "") + (item.noRedOnExpand ? " no-red-expand" : "")}>
                <div className="more-menu-list-item" onClick={() => setExpanded(!isExpanded)}>
                    <div className="more-menu-list-icon">
                        <img src={themedSrc(item.icon)} alt={item.label} />
                    </div>
                    <span className="more-menu-list-label">{item.label}</span>
                    <span className={"more-menu-chevron expandable-chevron" + (isExpanded ? " rotated" : "")}><img src={themedSrc("content/images/more-menu/ico_chevron_down.png")} alt="" /></span>
                </div>
                <div className="more-menu-expandable-content">
                    {item.children.map(child => {
                        if (child.href) {
                            return <a key={child.key} href={child.href} target="_blank" rel="noopener noreferrer" className="more-menu-subitem" onClick={closeMenu}>{child.label}</a>;
                        }
                        return <NavLink key={child.key} to={child.to} className="more-menu-subitem" onClick={closeMenu}>{child.label}</NavLink>;
                    })}
                </div>
            </div>
        );
    }

    function renderCardGridItem(item) {
        return renderLink(item, "more-menu-card-item", <>
            <div className="more-menu-card-icon">
                <img src={themedSrc(item.icon)} alt={item.label} />
            </div>
            <span className="more-menu-card-label">{item.label}</span>
        </>);
    }

    function renderCardGrid4Item(item) {
        return renderLink(item, "more-menu-card4-item", <>
            <div className="more-menu-card4-icon">
                <img src={themedSrc(item.icon)} alt={item.label} />
            </div>
            <span className="more-menu-card4-label">{item.label}</span>
        </>);
    }

    function renderSectionItems(section) {
        if (section.type === "card-grid") {
            return (
                <div className="more-menu-card-grid">
                    {section.items.map(item => renderCardGridItem(item))}
                </div>
            );
        }
        if (section.type === "card-grid-4") {
            return (
                <div className="more-menu-card-grid-4">
                    {section.items.map(item => renderCardGrid4Item(item))}
                </div>
            );
        }
        if (section.type === "grid") {
            return (
                <div className="more-menu-grid">
                    {section.items.map(item => renderGridItem(item))}
                </div>
            );
        }
        return (
            <div className="more-menu-list">
                {section.items.map(item =>
                    item.expandable ? renderExpandableItem(item) : renderListItem(item)
                )}
            </div>
        );
    }

    function renderQuickAccessItem(item) {
        var content = <>
            <div className="qa-icon">
                <img src={themedSrc(item.icon)} alt={item.label} />
            </div>
            <span className="qa-label">{item.label}</span>
            <span className="qa-sublabel">{item.sublabel}</span>
        </>;

        if (item.href) {
            return (
                <a key={item.key} href={item.href} target="_blank" rel="noopener noreferrer" className={"quick-access-btn " + item.className} onClick={closeMenu}>
                    {content}
                </a>
            );
        }
        return (
            <NavLink key={item.key} to={item.to} className={"quick-access-btn " + item.className} onClick={closeMenu}>
                {content}
            </NavLink>
        );
    }

    function renderUserIcons() {
        if (!props.userChecked || !props.user) return null;
        return (
            <div className="more-menu-user-icons">
                <NavLink className="account" onClick={closeMenu} to={props.getHomePathFn(props.location, '/super-story')}>
                    <img src={themedSrc("content/images/obavijesti/ic_profile_story_new.png")} />
                    <span className={"broj-notifikacija " + (props.important ? "important" : (props.stories ? "active" : "inactive"))}></span>
                </NavLink>
                <NavLink className="account" onClick={closeMenu} to={props.getHomePathFn(props.location, '/obavijesti')}>
                    <img src={themedSrc("content/images/obavijesti/ic_notification_bel_new.png")} />
                    <span className={"broj-notifikacija " + (props.important ? "important" : (props.brojNotifikacija ? "active" : "inactive"))}></span>
                </NavLink>
                <NavLink className="account" onClick={closeMenu} to={props.getHomePathFn(props.location, '/account')}>
                    <img src={themedSrc("content/images/obavijesti/ic_profile_avatar_new.png")} />
                </NavLink>
            </div>
        );
    }

    return (
        <div className={"more-menu-overlay" + (props.showMoreMenu ? " active" : "")}>
            <div className="more-menu-container">
                <div className="more-menu-header">
                    <div className="more-menu-header-top">
                        <div className="more-menu-title-row">
                            <img src={themedSrc("content/images/more-menu/ico_hamburger.png")} alt="" className="more-menu-hamburger" />
                            <h1 className="more-menu-title">Više</h1>
                        </div>
                        {renderUserIcons()}
                    </div>
                </div>

                <div className="more-menu-content">
                    <div className="more-menu-quick-access">
                        {QUICK_ACCESS_ITEMS.map(item => renderQuickAccessItem(item))}
                    </div>

                    {menuSections.map(section => (
                        <div key={section.key} className="more-menu-section">
                            {section.title && <h3 className="more-menu-section-title">{section.title}</h3>}
                            {renderSectionItems(section)}
                        </div>
                    ))}

                    <div className="more-menu-disclaimer">
                        <span>Igre na sreću mogu uzrokovati ovisnost. Igraj odgovorno.</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(MoreMenu);
